var path = '/glow/component/glow-cart/tpl/cart-buttons.html';
var html = "<div class=\"recipient-buttons row\"> <div class=col-xs-6> <button class=\"btn btn-block btn-tm btn-default\" ng-class=\"{disabled: to.endUserCount == 1}\" ng-click=to.removeEndUser($event)> REMOVE RECIPIENT <span class=\"glyphicon glyphicon-remove\"></span> </button> </div> <div class=col-xs-6> <button class=\"btn btn-tm btn-default btn-block\" ng-click=\"to.addEndUser($event, false)\"> ADD RECIPIENT <span class=\"glyphicon glyphicon-plus\"></span> </button> </div> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/glow/component/glow-cart/tpl/cart-buttons.html
// module id = 1695
// module chunks = 1